<div class="box">
    <div class="myForm">
        <div class="card">
            <h4 class="card-header">Import OSH & Dap Content using Excel Template</h4>
            <div class="card-body scroll" style="max-height: 550px;">
                <form #oshForm="ngForm">
                    <p>
                        <mat-form-field appearance="outline" color="primary">
                            <mat-label>Client</mat-label>
                            <mat-select name="client" placeholder="Client" [(ngModel)]="osh.client" required>
                                <mat-option *ngFor="let item of clients" [value]="item.id">{{item.dname}}</mat-option>
                            </mat-select>
                            <mat-error>*Client is required</mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <button color="primary" class="button" type="button" mat-raised-button
                            (click)="fileInput1.click()" required>
                            <mat-icon>attachment</mat-icon>
                            First Six Days Excel File*
                        </button>
                        <input hidden (change)="onFileSelected2($event)" #fileInput1 name="xl1" type="file"
                            accept=".xls, .xlsx" [(ngModel)]="osh.firstSixDaysExcelFile" #xl1="ngModel" required />
                        <br>
                        <span>
                            <mat-hint><b>{{ osh.firstSixDaysExcelFile?.name ? osh.firstSixDaysExcelFile?.name : "&nbsp;"
                                    }}
                                    <button color="primary" class="remove" *ngIf="osh.firstSixDaysExcelFile?.name"
                                        mat-button (click)="remove_xl2()">
                                        <mat-icon>delete_forever</mat-icon>
                                    </button>
                                </b></mat-hint>
                        </span>
                    </p>
                    <p>
                        <button color="primary" class="button" type="button" mat-raised-button
                            (click)="fileInput2.click()" required>
                            <mat-icon>attachment</mat-icon>
                            Post Six Days Excel File*
                        </button>
                        <input hidden (change)="onFileSelected3($event)" #fileInput2 name="xl2" type="file"
                            accept=".xls, .xlsx" [(ngModel)]="osh.postSixDaysExcelFile" #xl2="ngModel" required />
                        <br>
                        <span>
                            <mat-hint><b>{{ osh.postSixDaysExcelFile?.name ? osh.postSixDaysExcelFile?.name : "&nbsp;"
                                    }}
                                    <button color="primary" class="remove" *ngIf="osh.postSixDaysExcelFile?.name"
                                        mat-button (click)="remove_xl3()">
                                        <mat-icon>delete_forever</mat-icon>
                                    </button>
                                </b></mat-hint>
                        </span>
                    </p>
                    <p>
                        <button color="primary" class="button" type="button" mat-raised-button
                            (click)="fileInput.click()" required>
                            <mat-icon>attachment</mat-icon>
                            Osh Framework Excel File*
                        </button>
                        <input hidden (change)="onFileSelected1($event)" #fileInput name="xl2" type="file"
                            accept=".xls, .xlsx" [(ngModel)]="osh.oshFrameworkExcelFile" #xl="ngModel" required />
                        <br>
                        <span>
                            <mat-hint><b>{{ osh.oshFrameworkExcelFile?.name ? osh.oshFrameworkExcelFile?.name : "&nbsp;"
                                    }}
                                    <button color="primary" class="remove" *ngIf="osh.oshFrameworkExcelFile?.name"
                                        mat-button (click)="remove_xl1()">
                                        <mat-icon>delete_forever</mat-icon>
                                    </button>
                                </b></mat-hint>
                        </span>
                    </p>
                    <p>
                        <button color="primary" class="button" type="button" mat-raised-button
                            (click)="fileInput3.click()" required>
                            <mat-icon>attachment</mat-icon>
                            Zip File*
                        </button>
                        <input hidden (change)="onFileSelected4($event)" #fileInput3 name="xl3" type="file"
                            accept=".zip" [(ngModel)]="osh.zipFile" #xl3="ngModel" required />
                        <br>
                        <span>
                            <mat-hint><b>{{ osh.zipFile?.name ?
                                    osh.zipFile?.name : "&nbsp;" }}
                                    <button color="primary" class="remove" *ngIf="osh.zipFile?.name" mat-button
                                        (click)="remove_xl4()">
                                        <mat-icon>delete_forever</mat-icon>
                                    </button>
                                </b></mat-hint>
                        </span>
                    </p>
                    <p>
                        <button color="primary" class="button btn-spc" [disabled]="!oshForm.valid || buttonClicked"
                            (click)="upload(false)" mat-raised-button>
                            {{ buttonClicked && !status ? "Verifying" : "Verify" }}
                            <span>
                                <mat-icon *ngIf="buttonClicked && !status">
                                    <mat-spinner diameter="25"></mat-spinner>
                                </mat-icon>
                            </span>
                        </button>
                    </p>
                    <p>
                        <button color="primary" class="button float-left" [disabled]="!success || resp == null"
                            (click)="response( true )" mat-raised-button> View
                            Log </button>
                        <button color="primary" class="button float-right" [disabled]="!oshForm.valid || buttonClicked"
                            (click)="upload(true)" type="submit" mat-raised-button>
                            {{ buttonClicked && status ? "Uploading" : "Upload" }}
                            <span>
                                <mat-icon *ngIf="buttonClicked && status">
                                    <mat-spinner diameter="25"></mat-spinner>
                                </mat-icon>
                            </span>
                        </button>
                    </p>
                </form>
            </div>
        </div>
    </div>
</div>